import React, { Component } from 'react';
import ReviewDetailPageController from './reviews-detail.controller';
import Inherit from '../../core/inherit';
import withHooks from '../../core/withHooks';
import Page from '../common/page/Page';
import { SCOPES } from '../../constants/scopes.constants';
import ReviewBasicInfoCard from './elements/ReviewBasicInfoCard';
import ReviewAdvanceDetailsCard from './elements/ReviewAdvanceDetailsCard';
import ReviewSupportTicketCard from './elements/ReviewSupportTicketCard';
import CreateTicketModal from '../support/elements/CreateTicketModal';
import styles from './styles/reviews-detail.module.scss';

class ReviewDetailPage extends Inherit(ReviewDetailPageController, Component) {
    render() {
        const {
            review,
            loading,
            error,
            createTicketModalOpen,
            ticketSubmitting,
        } = this.state;

        const pageError = error ? {
            isError: true,
            title: 'Error Loading Review',
            subTitle: error,
        } : null;

        return (
            <Page
                role="user"
                scope={SCOPES.REVIEWS_VIEW}
                title={{
                    text: 'Review',
                    highlight: 'Details',
                }}
                description="View user feedback."
                isLoading={loading}
                error={pageError}
                goBack={{
                    label: 'Back to Reviews',
                    onClick: () => this.navigateToReviews(),
                }}
            >
                {review && (
                    <>
                        <div className={styles.pageContent}>
                            <ReviewBasicInfoCard review={review} />
                            <ReviewAdvanceDetailsCard review={review} />
                            <ReviewSupportTicketCard
                                review={review}
                                onCreateTicket={this.handleOpenCreateTicketModal.bind(this)}
                                onGoToTicket={this.handleGoToTicket.bind(this)}
                            />
                        </div>
                        <CreateTicketModal
                            open={createTicketModalOpen}
                            submitting={ticketSubmitting}
                            subject={this.state.newTicketSubject}
                            body={this.state.newTicketBody}
                            attachments={this.state.newTicketAttachments}
                            category={this.state.newTicketCategory}
                            priority={this.state.newTicketPriority}
                            onSubjectChange={(v) => this.setNewTicketSubject(v)}
                            onBodyChange={(v) => this.setNewTicketBody(v)}
                            onAttachmentsChange={(v) => this.setNewTicketAttachments(v)}
                            onCategoryChange={(v) => this.setNewTicketCategory(v)}
                            onPriorityChange={(v) => this.setNewTicketPriority(v)}
                            onCancel={this.handleCloseCreateTicketModal.bind(this)}
                            onSubmit={this.handleCreateTicketSubmit.bind(this)}
                            title="Create Support Case"
                            description="A support case will be created and linked to this review."
                        />
                    </>
                )}
            </Page>
        );
    }
}

export default withHooks(ReviewDetailPage);
